// import lottie from 'lottie-web';

(function ready(fn) {
    if (document.readyState != 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
})(() => {
    /* ------------------------------------*\
        LIVECHAT
    \*------------------------------------*/
    document.querySelector('.start-chat').addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelector('.live-chat-activator').click();
    });
    /* ------------------------------------*\
        ANIMATE
    \*------------------------------------*/
    // const res2dppx = window.matchMedia('(min-resolution: 2dppx)').matches;
    // const isDesktop = window.matchMedia('(min-width: 600px)').matches;

    // const lotties = JSON.parse(document.querySelector('#lotties').innerHTML);

    // const animData = {
    //     'lottie-livechat': {
    //         container: document.getElementById('lottie-livechat'),
    //         renderer: 'svg',
    //         loop: true,
    //         autoplay: !isDesktop,
    //         path: lotties.livechat[res2dppx ? '@2x' : '@1x'],
    //     },
    // };

    // const anim = {};
    // anim['lottie-livechat'] = lottie.loadAnimation(animData['lottie-livechat']);

    // Object.keys(anim).forEach((a) => {
    //     anim[a].addEventListener('loaded_images', () => {
    //         anim[a].play();
    //     });
    // });
});